<template>
  <div class="view-toggle" :aria-label="ariaLabel">
    <span class="view-toggle-indicator" :style="indicatorStyle"></span>
    <button
        v-for="(option, index) in normalizedOptions"
        :key="option.id"
        type="button"
        :class="{ active: isActive(option) }"
        :aria-pressed="isActive(option)"
        :uk-tooltip="option.tooltip"
        @click.prevent="handleClick(option, index)">
      <i :class="option.icon"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "ViewToggle",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      required: false,
      default: null,
    },
    modelValue: {
      required: false,
      default: null,
    },
    options: {
      type: Array,
      default: () => ([
        { id: 1, icon: "icon-feather-grid", tooltip: "" },
        { id: 2, icon: "icon-feather-list", tooltip: "" }
      ])
    },
    ariaLabel: {
      type: String,
      default: "View mode"
    }
  },
  computed: {
    normalizedOptions() {
      return this.options.slice(0, 2);
    },
    activeId() {
      if (this.value !== null && this.value !== undefined) return this.value;
      if (this.modelValue !== null && this.modelValue !== undefined) return this.modelValue;
      return this.normalizedOptions[0]?.id ?? null;
    },
    indicatorStyle() {
      const index = Math.max(this.normalizedOptions.findIndex(opt => this.isActive(opt)), 0);
      return {
        transform: `translateX(${index * 100}%)`
      };
    }
  },
  methods: {
    isActive(option) {
      return option.id === this.activeId;
    },
    handleClick(option) {
      if (option.id === this.activeId) return;
      this.$emit("input", option.id);
      this.$emit('update:modelValue', option.id);
      this.$emit('change', option.id);
    }
  }
}
</script>

<style scoped>
.view-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #eef1f7;
  border-radius: 12px;
  padding: 2px;
  gap: 0;
  min-width: 92px;
  border: 1px solid #e0e3ed;
}

.view-toggle button {
  position: relative;
  z-index: 1;
  width: 36px;
  height: 32px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #7b7c93;
  cursor: pointer;
  transition: color 0.2s ease;
  outline: none;
  box-shadow: none;
}

.view-toggle button.active {
  color: #3e416d;
  background: transparent;
  font-weight: 600;
}

.view-toggle button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(62, 65, 109, 0.2);
}

.view-toggle-indicator {
  position: absolute;
  top: 2px;
  left: 2px;
  width: calc(50% - 1px);
  height: 32px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease;
}
</style>

